// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, setServiceProperties, getServiceProperties } from "./operations.js";
export type {
  QueueServicesListOptionalParams,
  QueueServicesSetServicePropertiesOptionalParams,
  QueueServicesGetServicePropertiesOptionalParams,
} from "./options.js";
